import { FEATURE_AGENTS_MODULE } from "@/constants";
import { Profile } from "@/models";
import ClientUserInfo from "@/models/Agents/UserInfo";

export class ProfileCapabilitiesService {
  static agentsModuleEnabled(
    profile?: Profile,
    agentUserInfos?: ClientUserInfo
  ): boolean {
    return (
      (profile?.hasFeature(FEATURE_AGENTS_MODULE) ?? false) && !!agentUserInfos
    );
  }
}
